<template>
  <div
    v-sc-non-empty="breadcrumb"
    v-sc-non-empty-string="title"
    :class="{
      'post-breadcrumbs px-7 pb-5 pt-[42px] text-10px font-medium capitalize leading-5 text-www-color-neutral-medium-dark md:px-0 md:py-[22px] md:text-xs lg:py-30px lg:text-15px': true,
    }"
    data-testid="BreadCrumb"
  >
    <div :class="{ 'fluid-container mx-auto': true }">
      <nav aria-label="breadcrumb">
        <ol
          itemscope
          itemtype="https://schema.org/BreadcrumbList"
          :class="{
            'breadcrumb flex': true,
          }"
        >
          <li
            v-for="(crumb, index) in breadcrumb"
            :key="index"
            :class="{
              'breadcrumb-item': true,
            }"
            itemprop="itemListElement"
            itemscope
            itemtype="https://schema.org/ListItem"
          >
            <nuxt-link
              :class="{
                'whitespace-nowrap text-www-color-primary-light': true,
              }"
              itemprop="item"
              itemscope
              itemtype="https://schema.org/WebPage"
              :to="`${langPrefix}${crumb.to}/`"
              >{{ crumb.text.replace('-', ' ') }}</nuxt-link
            >
            <span
              :class="{
                'mx-1': true,
              }"
              itemprop="name"
              >&gt;</span
            >
          </li>
          <div
            :class="{
              'overflow-hidden text-ellipsis whitespace-nowrap text-www-color-neutral-medium md:overflow-visible': true,
            }"
          >
            {{ title }}
          </div>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  breadcrumb: {
    type: Array<{
      text: string;
      to: string;
    }>,
    required: true,
  },
});

const route = useRoute();
const langPrefix = '/' + route.path.split('/')[1];

useHead({
  htmlAttrs: {
    // @ts-expect-error: `itemscope` is a valid HTML attribute, but not typed
    itemscope: '',
    itemtype: 'https://schema.org/BreadcrumbList',
  },
});
</script>
